import React from 'react';
import { Home, User, MessageSquare } from 'lucide-react';
import Button from '../components/ui/Button';
import Card from '../components/ui/Card';

const HomePage = ({ navigateTo }) => {
  const features = [
    {
      icon: <Home size={48} />,
      title: "Modern Design",
      description: "Clean, responsive designs that look great on all devices."
    },
    {
      icon: <User size={48} />,
      title: "User-Focused",
      description: "We prioritize user experience in everything we create."
    },
    {
      icon: <MessageSquare size={48} />,
      title: "24/7 Support",
      description: "Round-the-clock support to help you succeed."
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-purple-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              Welcome to Aether MindTech
            </h1>
            <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
              We create stunning digital experiences that help your business grow and succeed in the modern world.
            </p>
            <div className="space-x-4">
              <Button onClick={() => navigateTo('about')} variant="secondary">
                Learn More
              </Button>
              <Button onClick={() => navigateTo('contact')} variant="outline">
                Get Started
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Why Choose Us?
            </h2>
            <p className="text-xl text-gray-600">
              We deliver exceptional results with modern technology and creative solutions.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <Card key={index} className="text-center p-6" hover>
                <div className="text-blue-600 mb-4 flex justify-center">{feature.icon}</div>
                <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;